import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useTable, useSortBy, usePagination } from 'react-table'
import moment from "moment";
import { fetctVessels } from '../../redux/action/company-vessel-chart.action';


function Table({ columns, data, fetchData, pageCount: controlledPageCount, props, dispatch }) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize, sortBy },
  } = useTable(
    {
      autoResetPage: false,
      columns,
      data,
      initialState: {
        hiddenColumns: ["vessel.imo", "vessel.lastVesselVisit.company.id", "vessel.lastVesselVisit.company.url"],
        sortBy: [{
          id: "vd.detailkey",
          desc: true
        }],
      },
      manualSortBy: true,
      manualPagination: true,
      pageCount: controlledPageCount,
    },
    useSortBy,
    usePagination,
  );



  useEffect(() => {
    fetchData({ pageIndex, pageSize, sortBy });
  }, [pageIndex, pageSize, sortBy]);

  // Render the UI for your table
  return (
    <>

      <table className={"table-default dataTable search-results-table"} {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? <i className="fa fa-sort-desc" aria-hidden="true"></i>
                        : <i className="fa fa-sort-asc" aria-hidden="true"></i>
                      : ''}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      <div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <span>
          Page{' '}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{' '}
        </span>
        <span>
          | Go to page:{' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{ width: '100px' }}
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      </div>
    </>
  )
}

export const InspecitonsContainer = (props) => {
  const dispatch = useDispatch();
  let referencedVessel = useSelector(state => state.companyVesselChartData.inspections);
  let filter = useSelector(state => state.filter);
  let filterSerial = useSelector(state => state.filter.filterSerial);
  let vesselDetail = useSelector(state => state.vessel.detail);

  const [pageCount, setPageCount] = useState(0);
  const fetchIdRef = useRef(0);
  const [tableProps, setTableProps] = useState({
    "sortByColumn": "vessel.nextSurvey",
    "orderDir": false,
    "pageIndex": 0,
    "pageSize": 10
  });
  const sortByColumnOriRef = useRef("vd.detailkey")
  const orderDirRef = useRef(true)
  const pageIndexRef = useRef(0)
  const pageSizeRef = useRef(10)


  useEffect(() => {
    if (referencedVessel) {
      setPageCount(Math.ceil(referencedVessel.recordsTotal / 10));
    }
  }, [referencedVessel])

  useEffect(() => {
    fetchData({
      "keyword": filter.keyword ? filter.keyword : (vesselDetail ? vesselDetail.detailValueForSearch : ""),
      pageSize: pageSizeRef.current,
      pageIndex: pageIndexRef.current,
      sortBy: [{
        id: sortByColumnOriRef.current,
        desc: orderDirRef.current
      }]
    });
  }, [filterSerial])


  const fetchData = ({ pageSize, pageIndex, sortBy }) => {
    // Give this fetch an ID
    const fetchId = ++fetchIdRef.current;
    // Only update the data if this is the latest fetch
    let sortByColumn = "";
    let direction = "desc";
    if (sortBy.length > 0) {
      sortByColumn = sortBy[0].id;
      sortBy[0].desc ? direction = "desc" : direction = "asc"
      sortByColumnOriRef.current = sortBy[0].id
      orderDirRef.current = sortBy[0].desc
    }
    pageIndexRef.current = pageIndex
    pageSizeRef.current = pageSize


    dispatch(fetctVessels({
      "keyword": filter.keyword ? filter.keyword : (vesselDetail ? vesselDetail.detailValueForSearch : ""),
      "draw": fetchId,
      "orderByColumn": sortByColumn,
      "orderDir": direction,
      "start": pageIndex * pageSize,
      "length": pageSize,
    }))

    setPageCount(Math.ceil(referencedVessel.recordsTotal / pageSize));

  };

  const columns = React.useMemo(
    () => [

      {
        Header: 'Vessel',
        accessor: 'v.vesselname',
        Cell: ({ row }) => {
          return (
            <span>
              {row.original.vessel &&
                <>
                  <a href={row.original.vessel.url} target="_blank">{row.original.vessel.name}</a>
                </>
              }
            </span>
          )
        }
      },
            {
        Header: 'Manager Country',
        accessor: 'v.manager_country_name',
        Cell: ({ row }) => {
          return (
            <span>
              {row.original.vessel?.manager?.country &&
                <>
                  <span className={`flag flag-icon-background flag-icon-${row.original.vessel.manager.country.a2.toLowerCase()}`} alt={row.original.vessel.manager.country.name} title={row.original.vessel.manager.country.name}></span>{row.original.vessel.manager.country.name}
                </>
              }
            </span>
          )
        }
      },
      {
        Header: 'ISM Manager',
        accessor: 'v.manager_in_text',
        Cell: ({ row }) => {
          return (
            <span>
              {row.original.vessel?.manager &&
                <>
                  <a href={row.original.vessel.manager.url} target="_blank">{row.original.vessel.manager.name}</a>
                </>
              }
            </span>
          )
        }
      },
      {
        Header: 'Vessel Type',
        accessor: 'v.vessel_type',
        Cell: ({ row }) => {
          return (
            <span>
              {row.original.vessel.vesselTypeClean
              }
            </span>
          )
        }
      },
      {
        Header: 'Detail Key',
        accessor: 'vd.detailkey',
        Cell: ({ row }) => {
          return (
            <span>
              {row.original.detailKey
              }
            </span>
          )
        }
      },
      {
        Header: 'Detail Value',
        accessor: 'vd.detailvalue',
        Cell: ({ row }) => {
          return (
            <span>
              {row.original.detailValue
              }
            </span>
          )
        }
      },
    ],
    []
  )

  return (
    <>
      {
        referencedVessel.recordsTotal > 0 &&
        <Table columns={columns} data={referencedVessel.data} fetchData={fetchData} pageCount={pageCount} props={props}
          dispatch={dispatch} />
      }
      {
        referencedVessel.recordsTotal === 0 &&
        <div className="alert alert-info">
          <i className="fa fa-info-circle" aria-hidden="true"></i> No vessels found for this equipment.
        </div>
      }
    </>
  );
}

export default InspecitonsContainer;